export default __webpack_public_path__ + "static/media/modal-close-button-white.c1466a54.svg";